import AsyncStorage from "@react-native-async-storage/async-storage";
import { activityPath, DEMO_FLOW_ENABLED } from "../../config/Constant";

import SPA_TREATMENTS from "../../demo/spa/getSpaTreatments.json"
import SPA_ALL_APPOINTMENTS from "../../demo/spa/getAllAppointments.json"
import SPA_SEARCH_AVAILABILITY from "../../demo/spa/searchSpaAvailability.json"
import SPA_ADD_ONS from "../../demo/spa/getAddOns.json"
import { spaBookingSuccess } from "../Reducers/spaReducer";


export const getSpaTreatmentList = (locationId, callback=()=>{}) => {
    return async (dispatch, getState) => {
        try {
            if(DEMO_FLOW_ENABLED){
                callback(true, SPA_TREATMENTS?.payload?.data);
                return
            }
            const { currentGuestDetails } = getState().guestDetailsSlice;
    
            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber") || currentGuestDetails?.reservationNumber;
            const guestToken = await AsyncStorage.getItem("guestToken");
    
            
            const response = await activityPath.post("/getSpaTreatments", {
                header: {
                    sessionToken,
                    reservationNumber,
                    guestToken
                },
                payload: locationId ? {
                    spaLocationId: locationId
                } : {}
            });

            if (response?.data?.header?.status?.code == "SUCCESS" && response?.data?.payload?.data?.length) {
                callback(true, response?.data?.payload?.data);
                dispatch(spaBookingSuccess(response?.data?.payload?.data));
                return
            }

            callback(false, response?.data?.header?.status?.msg || "Something went wrong") 
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || "Something went wrong";
            callback(false, errorMessage);
        }
    }
}

export const getMySpaBooking = (payload_, callback=()=>{}) => {
    return async (dispatch, getState) => {
        if(DEMO_FLOW_ENABLED){
            callback(true, SPA_ALL_APPOINTMENTS?.payload?.data);
            return
        }

        const { currentGuestDetails } = getState().guestDetailsSlice;
    
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber") || currentGuestDetails?.reservationNumber;
        const guestToken = await AsyncStorage.getItem("guestToken");
        
        try {
            let response = await activityPath.post(`/getAllAppointment`,{
                header: {
                    sessionToken,
                    reservationNumber,
                    guestToken
                },
                payload: payload_
            })

            if (response?.data?.header?.status?.code == "SUCCESS") {
                callback(true, response?.data?.payload?.data);
                return
            }

            callback(false, response?.data?.header?.status?.msg || "Something went wrong") 
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
        }

    }
}

export const getAddonsForSpa = (payload_, callback=()=>{}) => {
    return async (dispatch, getState) => {
        if(DEMO_FLOW_ENABLED){
            callback(true, SPA_ADD_ONS?.payload?.data);
            return
        }
        
        const { currentGuestDetails } = getState().guestDetailsSlice;
    
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber") || currentGuestDetails?.reservationNumber;
        const guestToken = await AsyncStorage.getItem("guestToken");
        
        try {
            let response = await activityPath.post(`/getAddonServices`,{
                header: {
                    sessionToken,
                    reservationNumber,
                    guestToken
                },
                payload: payload_
            })

            if (response?.data?.header?.status?.code == "SUCCESS") {
                callback(true, response?.data?.payload?.data);
                return
            }

            callback(false, response?.data?.header?.status?.msg || "Something went wrong") 
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
        }

    }
}

export const searchSpaAvailability = (payload_, callback=()=>{}) => {
    return async (dispatch, getState) => {
        if(DEMO_FLOW_ENABLED){
            callback(true, SPA_SEARCH_AVAILABILITY?.payload?.data);
            return
        }
        const { currentGuestDetails } = getState().guestDetailsSlice;
    
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber") || currentGuestDetails?.reservationNumber;
        const guestToken = await AsyncStorage.getItem("guestToken");
        
        try {
            let response = await activityPath.post(`/searchSpaAvailability`,{
                header: {
                    sessionToken,
                    reservationNumber,
                    guestToken
                },
                payload: payload_
            })

            if (response?.data?.header?.status?.code == "SUCCESS") {
                callback(true, response?.data?.payload?.data);
                return
            }

            callback(false, response?.data?.header?.status?.msg || "Something went wrong") 
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
        }

    }
}


export const makeSpaBooking = (payload_, callback=()=>{}) => {
    return async (dispatch, getState) => {
        if(DEMO_FLOW_ENABLED){
            callback(true, "Booking created");
            return
        }

        const { currentGuestDetails } = getState().guestDetailsSlice;
    
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber") || currentGuestDetails?.reservationNumber;
        const guestToken = await AsyncStorage.getItem("guestToken");
        
        try {
            let response = await activityPath.post(`/saveAppointment`,{
                header: {
                    sessionToken,
                    reservationNumber,
                    guestToken
                },
                payload: payload_
            })

            if (response?.data?.header?.status?.code == "SUCCESS") {
                callback(true, response?.data?.payload?.data);
                return
            }

            callback(false, response?.data?.header?.status?.msg || "Something went wrong") 
        } catch (error) {
                const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
        }

    }
}


export const updateMySpaBooking = (payload_, callback=()=>{}) => {
    return async (dispatch, getState) => {
        if(DEMO_FLOW_ENABLED){
            callback(true, "Booking updated");
            return
        }
        const { currentGuestDetails } = getState().guestDetailsSlice;
    
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber") || currentGuestDetails?.reservationNumber;
        const guestToken = await AsyncStorage.getItem("guestToken");
        
        try {
            let response = await activityPath.post(`/updateAppointment`,{
                header: {
                    sessionToken,
                    reservationNumber,
                    guestToken
                },
                payload: payload_
            })

            if (response?.data?.header?.status?.code == "SUCCESS") {
                callback(true, response?.data?.payload?.data);
                return
            }

            callback(false, response?.data?.header?.status?.msg || "Something went wrong") 
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
        }

    }
}